import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import "./viewBooking.css";
import CustomRewardPointsPopup from "./customPopup";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getBookingsListById,
  addRewardPoints,
  cancelBooking,
} from "../../Redux/Actions/bookingActions";
import { ReactComponent as View } from "../../Global Icons/View Modal.svg";
import PriceDetailModal from "../../Global Functions/priceDetailModal";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import UpdateLegalDocumentsPopup from "./legalDocument";
import { TailSpin } from "react-loader-spinner";
import FinalSummaryPopup from "./finalSummaryPopup";
import toast from "react-hot-toast";

const Row = ({ label, value }) => {
  const empty = value === undefined || value === null || value === "";
  return (
    <div className="vb-row">
      <span className="vb-row__key">{label}</span>
      <span className={`vb-row__val${empty ? " vb-row__val--muted" : ""}`}>
        {empty ? "—" : value}
      </span>
    </div>
  );
};

const statusClass = (s = "") => {
  const v = s.toLowerCase();
  if (v === "confirmed") return "vb-badge--confirmed";
  if (v === "pending") return "vb-badge--pending";
  if (v === "cancelled") return "vb-badge--cancelled";
  return "vb-badge--default";
};

const ViewBooking = () => {
  const { id } = useParams();

  const [pricePopup, setPricePopup] = useState(false);
  const [rewardPointsPopup, setRewardPointsPopup] = useState(false);
  const [confirmReward, setConfirmReward] = useState(false);
  const [pendingPoints, setPendingPoints] = useState(null);
  const [notePopup, setNotePopup] = useState(false);
  const [legalDocsPopup, setLegalDocsPopup] = useState(false);
  const [noteLoading, setNoteLoading] = useState(false);
  const [finalSummaryPopup, setFinalSummaryPopup] = useState(false);

  const [refundPopup, setRefundPopup] = useState(false);
  const [refundType, setRefundType] = useState("full");
  const [deductionPercentage, setDeductionPercentage] = useState(null);
  const [percentageError, setPercentageError] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [note, setNote] = useState("");

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => { dispatch(getBookingsListById(id)); }, [id, dispatch]);

  const { booking } = useSelector((state) => state.bookings || {});

  const legalDocsPopupHandler = () => setLegalDocsPopup(!legalDocsPopup);
  const priceModalHandler = () => setPricePopup(!pricePopup);
  const rewardPointsPopupHandler = () => setRewardPointsPopup(!rewardPointsPopup);

  const notePopupHandler = () => {
    setNotePopup(!notePopup);
    setNote("");
  };

  const handleNoteChange = (e) => setNote(e.target.value);

  const handleNoteSubmit = () => {
    if (!note.trim()) {
      toast.error("Please enter a note");
      return;
    }

    setRefundType("full");
    setDeductionPercentage(null);
    setPercentageError("");
    setRefundPopup(true);
  };

  const handleCancelBookingConfirmed = () => {
    if (refundType === "partial") {
      if (
        deductionPercentage === null ||
        deductionPercentage === undefined ||
        deductionPercentage === ""
      ) {
        setPercentageError("Please enter a deduction percentage.");
        return;
      }

      if (deductionPercentage < 0 || deductionPercentage > 100) {
        setPercentageError("Percentage must be between 0 and 100.");
        return;
      }
    }

    setCancelLoading(true);

    dispatch(
      cancelBooking({
        booking_id: booking?.data?._id,
        note: note.trim(),
        refund_status: refundType,
        ...(refundType === "partial" && {
          amount: deductionPercentage,
        }),
      })
    ).then((res) => {
      setCancelLoading(false);

      if (res && res.statusCode === 200) {
        toast.success("Booking cancelled successfully!");
        setNotePopup(false);
        setRefundPopup(false);
        setNote("");
        setRefundType("full");
        setDeductionPercentage(null);
        setPercentageError("");
        dispatch(getBookingsListById(id));
      } else {
        toast.error("Failed to cancel booking. Please try again.");
      }
    });
  };

  const handleRewardPointsSubmit = (points) => {
    setPendingPoints(points);
    setConfirmReward(true);
  };

  const handleRewardPointsSubmitConfirmed = () => {
    if (pendingPoints !== null) {
      dispatch(addRewardPoints({
        user_id: booking?.data?.user?._id,
        reward_points: Number(pendingPoints),
        booking_id: booking?.data?._id,
      })).then((res) => {
        if (res && res.status === "success") {
          toast.success("Reward points assigned successfully!");
          setRewardPointsPopup(false);
          dispatch(getBookingsListById(id));
        } else {
          toast.error("Failed to assign reward points. Please try again.");
        }
        setConfirmReward(false);
        setPendingPoints(null);
      });
    }
  };

  const isCancelled = booking?.data?.booking_status === "cancelled";
  const canReward = booking?.data?.booking_status === "confirmed" &&
    booking?.data?.booking_from !== "kiosk";
  const bookingStatus = booking?.data?.booking_status || "";
  const isAgentBooking = booking?.data?.booking_from === "agent";

  return (
    <div className="vb-root">

      <div className="header-top" style={{ marginLeft: "52%" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div className="vb-header">
        <div className="vb-header__left">
          <button style={{ background: "transparent" }} className="vb-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
            <BackIcon />
          </button>
          <div className="vb-header__sep" />
          <div className="vb-header__meta">
            <span className="vb-header__booking-id">
              {booking?.data?.booking_id || "—"}
            </span>
            <span className="vb-header__project-name">
              {booking?.data?.project?.project_name || "No project"}
            </span>
          </div>
        </div>

        <div className="vb-header__actions">
          {canAdd && (
            <button className="vb-btn vb-btn--ghost" onClick={legalDocsPopupHandler}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
              </svg>
              Legal Documents
            </button>
          )}

          {canAdd && booking?.data?.agent && (
            <button
              className="vb-btn vb-btn--ghost"
              onClick={() => setFinalSummaryPopup(true)}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
              </svg>
              {booking?.data?.final_summary && Object.keys(booking.data.final_summary).length > 0
                ? "Update Final Summary"
                : "Add Final Summary"}
            </button>
          )}

          {canEdit && (
            <button
              className={`vb-btn ${isCancelled ? "vb-btn--disabled" : "vb-btn--danger"}`}
              onClick={isCancelled ? null : notePopupHandler}
              disabled={isCancelled}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
              Cancel Booking
            </button>
          )}
        </div>
      </div>

      {legalDocsPopup && (
        <UpdateLegalDocumentsPopup
          bookingId={booking?.data?.booking_id}
          ID={booking?.data?._id}
          onClose={legalDocsPopupHandler}
          onUpdateSuccess={() => dispatch(getBookingsListById(id))}
        />
      )}

      <div className="vb-grid">

        <div className="vb-card vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--blue" />
              Booking Overview
            </span>
            <div className={`vb-badge ${statusClass(bookingStatus)}`}>
              <span className="vb-badge__dot" />
              {ToFirstCapital(bookingStatus) || "Unknown"}
            </div>
          </div>
          <div className="vb-card__body vb-card__body--row">
            <div className="vb-overview__aside">
              <img
                className="vb-overview__img"
                src={booking?.data?.project?.project_type?.image || ""}
                alt="Project"
              />
            </div>
            <div className="vb-overview__fields">
              <Row label="Project ID" value={booking?.data?.project?.project_id} />
              <Row label="Project Type" value={booking?.data?.project?.project_type?.name} />
              <Row label="Project Name" value={booking?.data?.project?.project_name} />
              <Row label="Booking Date" value={DateToLocale(booking?.data?.created_at)} />
              <Row label="Booking Amount" value={
                booking?.data?.booking_amount_currency && booking?.data?.booking_amount
                  ? `${booking.data.booking_amount_currency} ${Math.floor(booking.data.booking_amount * 100) / 100}`
                  : null
              } />
              <Row label="Booking From" value={ToFirstCapital(booking?.data?.booking_from)} />
              <Row label="Payment Status" value={ToFirstCapital(booking?.data?.payment_status)} />
              <Row label="Payment Method" value={ToFirstCapital(booking?.data?.payment_method)} />
            </div>
          </div>
        </div>

        <div className="vb-card vb-card--builder">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--amber" />
              Builder
            </span>
          </div>
          <div className="vb-card__body">
            <Row label="Brand Name" value={booking?.data?.builder?.brand_name} />
            <Row label="Builder ID" value={booking?.data?.builder?.builder_id} />
          </div>
        </div>

        <div className="vb-card vb-card--docs">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--violet" />
              Documents &amp; Executive
            </span>
          </div>
          <div className="vb-card__body">
            {canAdd && canEdit &&
              <div className="vb-row">
                <span className="vb-row__key">Booking PDF</span>
                <a
                  className="vb-link"
                  href={booking?.data?.booking_pdf_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="9" y1="13" x2="15" y2="13" />
                    <line x1="9" y1="17" x2="15" y2="17" />
                    <polyline points="9 9 10 9" />
                  </svg>
                  View
                </a>
              </div>
            }
            <Row label="Exec. Name" value={booking?.data?.payment_executive?.name} />
            <Row label="Exec. Contact" value={booking?.data?.payment_executive?.contact_number} />
          </div>
        </div>

        {
          isAgentBooking && (
            <div className="vb-card vb-card--agent vb-card--span2">
              <div className="vb-card__head">
                <span className="vb-card__title">
                  <span className="vb-card__dot vb-card__dot--teal" />
                  Agent Details
                </span>
                <div className="vb-badge vb-badge--agent">
                  <span className="vb-badge__dot" />
                  Agent Booking
                </div>
              </div>
              <div className="vb-card__body vb-card__body--row">
                <div className="vb-avatar-wrap">
                  {booking?.data?.agent?.profile_image ? (
                    <img className="vb-avatar vb-avatar--teal" src={booking.data.agent.profile_image} alt="Agent" />
                  ) : (
                    <div className="vb-avatar vb-avatar--initials vb-avatar--initials-teal">
                      {(booking?.data?.agent?.name || "?")[0].toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="vb-user-fields">
                  <Row label="Agent Name" value={booking?.data?.agent?.name} />
                  <Row label="Agent ID" value={booking?.data?.agent?.staff_id} />
                  <Row label="Email" value={booking?.data?.agent?.email} />
                  <Row label="Contact" value={
                    booking?.data?.agent?.country_code && booking?.data?.agent?.contact_number
                      ? `${booking.data.agent.country_code} ${booking.data.agent.contact_number}`
                      : booking?.data?.agent?.contact_number
                  } />
                </div>
              </div>
            </div>
          )
        }

        <div className="vb-card vb-card--user vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--blue" />
              User Details
            </span>
          </div>
          <div className="vb-card__body vb-card__body--row">
            <div className="vb-avatar-wrap">
              {booking?.data?.user?.profile_image ? (
                <img className="vb-avatar" src={booking.data.user.profile_image} alt="User" />
              ) : (
                <div className="vb-avatar vb-avatar--initials">
                  {(booking?.data?.user?.name || "?")[0].toUpperCase()}
                </div>
              )}
            </div>
            <div className="vb-user-fields">
              <Row label="Full Name" value={booking?.data?.user?.name} />
              <Row label="User ID" value={booking?.data?.user?.user_id || booking?.data?.user?._id} />
              <Row label="Email" value={booking?.data?.user?.email} />
              <Row label="Contact" value={
                booking?.data?.user?.country_code && booking?.data?.user?.contact_number
                  ? `${booking.data.user.country_code} ${booking.data.user.contact_number}`
                  : null
              } />
              <Row label="Reward Points" value={booking?.data?.user?.reward_points || "0"} />
            </div>
          </div>
        </div>


        {booking?.data?.final_summary && Object.keys(booking.data.final_summary).length > 0 && (
          <div className="vb-card vb-card--final vb-card--span2">
            <div className="vb-card__head">
              <span className="vb-card__title">
                <span className="vb-card__dot vb-card__dot--violet" />
                Final Summary
              </span>
            </div>

            <div className="vb-card__body">

              {/* ── Total Amount ── */}
              <div className="vb-fs-section">
                <div className="vb-fs-section__title">Total Amount</div>
                <div className="vb-fs-total">
                  <span className="vb-fs-total__currency">{booking?.data?.currency || "₹"}</span>
                  <span className="vb-fs-total__value">
                    {booking.data.final_summary?.total_amount
                      ? Math.floor(booking.data.final_summary.total_amount * 100) / 100
                      : "—"}
                  </span>
                </div>
              </div>

              <div className="vb-fs-divider" />

              {/* ── Tax & Deductions ── */}
              <div className="vb-fs-section">
                <div className="vb-fs-section__title">Tax & Deductions</div>
                <div className="vb-fs-grid">
                  {booking.data.final_summary?.deduction?._taxes !== undefined && (
                    <Row
                      label="Taxes"
                      value={(() => {
                        const t = booking.data.final_summary.deduction._taxes;
                        if (!t) return "—";
                        const val = t?.value ?? t;
                        const type = t?.type ?? "flat";
                        const totalAmt = booking.data.final_summary.total_amount || 0;
                        const resolved = type === "pct" ? (totalAmt * val) / 100 : val;
                        return `${booking?.data?.currency || "₹"} ${resolved.toLocaleString("en-IN", { maximumFractionDigits: 2 })}${type === "pct" ? ` (${val}%)` : ""}`;
                      })()}
                    />
                  )}
                  {booking.data.final_summary?.deduction?._tds !== undefined && (
                    <Row
                      label="TDS"
                      value={(() => {
                        const t = booking.data.final_summary.deduction._tds;
                        if (!t) return "—";
                        const val = t?.value ?? t;
                        const type = t?.type ?? "flat";
                        const totalAmt = booking.data.final_summary.total_amount || 0;
                        const resolved = type === "pct" ? (totalAmt * val) / 100 : val;
                        return `${booking?.data?.currency || "₹"} ${resolved.toLocaleString("en-IN", { maximumFractionDigits: 2 })}${type === "pct" ? ` (${val}%)` : ""}`;
                      })()}
                    />
                  )}
                  {booking.data.final_summary?.deduction &&
                    Object.entries(booking.data.final_summary.deduction)
                      .filter(([key]) => !["_taxes", "_tds"].includes(key) && key.startsWith("_"))
                      .map(([key, val]) => {
                        const value = val?.value ?? val;
                        const type = val?.type ?? "flat";
                        const totalAmt = booking.data.final_summary.total_amount || 0;
                        const resolved = type === "pct" ? (totalAmt * value) / 100 : value;
                        return (
                          <Row
                            key={key}
                            label={key.replace(/^_/, "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                            value={`${booking?.data?.currency || "₹"} ${resolved.toLocaleString("en-IN", { maximumFractionDigits: 2 })}${type === "pct" ? ` (${value}%)` : ""}`}
                          />
                        );
                      })
                  }
                </div>
              </div>

              <div className="vb-fs-divider" />

              {/* ── GST ── */}
              {(booking.data.final_summary?.gst_agent > 0 || booking.data.final_summary?.gst_admin > 0) && (
                <>
                  <div className="vb-fs-section">
                    <div className="vb-fs-section__title">GST</div>
                    <div className="vb-fs-grid">
                      {booking.data.final_summary?.gst_agent > 0 && (
                        <Row
                          label="Agent GST"
                          value={`${booking.data.final_summary.gst_agent}%`}
                        />
                      )}
                      {booking.data.final_summary?.gst_admin > 0 && (
                        <Row
                          label="Admin GST"
                          value={`${booking.data.final_summary.gst_admin}%`}
                        />
                      )}
                    </div>
                  </div>
                  <div className="vb-fs-divider" />
                </>
              )}

              {booking.data.final_summary?.notes && (
                <>
                  <div className="vb-fs-section">
                    <div className="vb-fs-section__title">Notes</div>
                    <p className="vb-fs-notes">{booking.data.final_summary.notes}</p>
                  </div>
                  <div className="vb-fs-divider" />
                </>
              )}

              {/* ── Margin Details ── */}
              <div className="vb-fs-section">
                <div className="vb-fs-section__title">Margin Details</div>

                {(() => {
                  const total = booking.data.final_summary?.total_amount || 0;
                  const deduction = booking.data.final_summary?.deduction || {};

                  const resolvePctOrFlat = (val, type) => {
                    const num = Number(val?.value ?? val) || 0;
                    const t = val?.type ?? type ?? "flat";
                    return t === "pct" ? (total * num) / 100 : num;
                  };

                  const taxesAmount = resolvePctOrFlat(deduction._taxes, "flat");
                  const tdsAmount = resolvePctOrFlat(deduction._tds, "flat");
                  const dynamicTotal = Object.entries(deduction)
                    .filter(([key]) => !["_taxes", "_tds"].includes(key) && key.startsWith("_"))
                    .reduce((sum, [, val]) => sum + resolvePctOrFlat(val, "flat"), 0);

                  const agentPct = booking.data.final_summary?.agent_margin || 0;
                  const adminPct = booking.data.final_summary?.admin_margin || 0;
                  const gstAgentPct = booking.data.final_summary?.gst_agent || 0;
                  const gstAdminPct = booking.data.final_summary?.gst_admin || 0;

                  const agentMarginAmount = (total * agentPct) / 100;
                  const adminMarginAmount = (total * adminPct) / 100;

                  const gstAgentAmount = (agentMarginAmount * gstAgentPct) / 100;
                  const gstAdminAmount = (total * gstAdminPct) / 100;

                  const agentFinal = agentMarginAmount - taxesAmount - tdsAmount - dynamicTotal + gstAgentAmount;
                  const adminFinal = adminMarginAmount + gstAdminAmount;

                  return (
                    <>
                      {/* Base box */}
                      <div className="vb-fs-remaining">
                        <span className="vb-fs-remaining__label">Base for margin split</span>
                        <span className="vb-fs-remaining__value">
                          {booking?.data?.currency || "₹"} {total.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                        </span>
                      </div>

                      {/* Split bar */}
                      {(agentPct > 0 || adminPct > 0) && (
                        <div className="vb-fs-bar-wrap">
                          <div className="vb-fs-bar">
                            <div className="vb-fs-bar__agent" style={{ width: `${agentPct}%` }} />
                            <div className="vb-fs-bar__admin" style={{ width: `${adminPct}%` }} />
                          </div>
                          <div className="vb-fs-bar__labels">
                            <span className="vb-fs-bar__label--agent">Agent {agentPct}%</span>
                            <span className="vb-fs-bar__label--admin">Admin {adminPct}%</span>
                          </div>
                        </div>
                      )}

                      <div className="vb-fs-margin-grid">
                        {/* Agent card */}
                        <div className="vb-fs-margin-card vb-fs-margin-card--agent">
                          <div className="vb-fs-margin-card__label">Agent Margin</div>
                          <div className="vb-fs-margin-card__pct">{agentPct}%</div>
                          <div className="vb-fs-margin-card__breakdown">
                            <div className="vb-fs-margin-card__row">
                              <span>Margin ({agentPct}%)</span>
                              <span>{booking?.data?.currency || "₹"} {agentMarginAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                            </div>
                            <div className="vb-fs-margin-card__row vb-fs-margin-card__row--deduct">
                              <span>− Taxes & TDS & Other</span>
                              <span>− {booking?.data?.currency || "₹"} {(taxesAmount + tdsAmount + dynamicTotal).toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                            </div>
                            {gstAgentPct > 0 && (
                              <div className="vb-fs-margin-card__row vb-fs-margin-card__row--add">
                                <span>+ GST ({gstAgentPct}%)</span>
                                <span>+ {booking?.data?.currency || "₹"} {gstAgentAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                              </div>
                            )}
                            <div className="vb-fs-margin-card__row vb-fs-margin-card__row--total">
                              <span>Agent Final</span>
                              <span>{booking?.data?.currency || "₹"} {agentFinal.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                            </div>
                          </div>
                        </div>

                        {/* Admin card */}
                        <div className="vb-fs-margin-card vb-fs-margin-card--admin">
                          <div className="vb-fs-margin-card__label">Admin Margin</div>
                          <div className="vb-fs-margin-card__pct">{adminPct}%</div>
                          <div className="vb-fs-margin-card__breakdown">
                            <div className="vb-fs-margin-card__row">
                              <span>Margin ({adminPct}%)</span>
                              <span>{booking?.data?.currency || "₹"} {adminMarginAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                            </div>
                            {gstAdminPct > 0 && (
                              <div className="vb-fs-margin-card__row vb-fs-margin-card__row--add">
                                <span>+ GST ({gstAdminPct}%)</span>
                                <span>+ {booking?.data?.currency || "₹"} {gstAdminAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                              </div>
                            )}
                            <div className="vb-fs-margin-card__row vb-fs-margin-card__row--total">
                              <span>Admin Final</span>
                              <span>{booking?.data?.currency || "₹"} {adminFinal.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>

            </div>
          </div>
        )}

        <div className="vb-card vb-card--payment vb-card--span2">
          <div className="vb-card__head">
            <span className="vb-card__title">
              <span className="vb-card__dot vb-card__dot--green" />
              Payment Details
            </span>
          </div>
          <div className="vb-card__body vb-card__body--grid3">
            <Row label="Total Amount" value={
              booking?.data?.total
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.total * 100) / 100}`
                : null
            } />
            <Row label="Sub Total" value={
              booking?.data?.sub_total
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.sub_total * 100) / 100}`
                : null
            } />
            <Row label="Location Charges" value={
              booking?.data?.preferred_location_charges !== undefined
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.preferred_location_charges * 100) / 100}`
                : booking?.data?.properties?.[0]?.preferred_location_charges !== undefined
                  ? `${booking.data.currency || ""} ${Math.floor(booking.data.properties[0].preferred_location_charges * 100) / 100}`
                  : null
            } />
            <Row label="Additional Charges" value={
              booking?.data?.additional_charges
                ? `${booking.data.currency || ""} ${Math.floor(booking.data.additional_charges * 100) / 100}`
                : null
            } />
            <Row label="Coupon Discount" value={
              booking?.data?.coupon_discount && booking.data.coupon_discount > 0
                ? `${booking.data.currency || ""} ${booking.data.coupon_discount}`
                : "No Coupon Applied"
            } />

            {/* ── Coupon Code Details ── */}
            <Row label="Coupon Code" value={
              booking?.data?.coupon_code
                ? booking.data.coupon_code
                : "N/A"
            } />

            <Row label="Gift Card" value={
              booking?.data?.gift_discount && booking.data.gift_discount > 0
                ? `${booking.data.currency || ""} ${booking.data.gift_discount}`
                : "No Gift Card Applied"
            } />

            {/* ── Reward Coupon Details ── */}
            <Row label="Reward Coupon Code" value={
              booking?.data?.reward_coupon?.code
                ? booking.data.reward_coupon.code
                : "N/A"
            } />
            <Row label="Reward Points" value={
              booking?.data?.reward_coupon?.reward_point
                ? booking.data.reward_coupon.reward_point
                : "N/A"
            } />
          </div>

          {canAdd && (
            <div style={{ padding: "0 24px 20px" }}>
              <button
                className={`vb-reward-btn ${canReward ? "" : "vb-reward-btn--off"}`}
                onClick={rewardPointsPopupHandler}
                disabled={!canReward}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                Assign Reward Points
              </button>
              {rewardPointsPopup && (
                <CustomRewardPointsPopup
                  onClose={rewardPointsPopupHandler}
                  onSubmit={handleRewardPointsSubmit}
                />
              )}
            </div>
          )}
        </div>

        {
          bookingStatus === "cancelled" && booking?.data?.refund_init_obj && (
            <div className="vb-card vb-card--refund vb-card--user vb-card--span2">
              <div className="vb-card__head">
                <span className="vb-card__title">
                  <span className="vb-card__dot vb-card__dot--red" />
                  Refund Details
                </span>
                <div className="vb-badge vb-badge--confirmed">
                  <span className="vb-badge__dot" />
                  {ToFirstCapital(booking.data.refund_init_obj.status) || "—"}
                </div>
              </div>
              <div className="vb-card__body vb-card__body--grid3">
                <Row label="Refund ID" value={booking.data.refund_init_obj.id} />
                <Row label="Payment ID" value={booking.data.refund_init_obj.payment_id} />
                <Row label="Receipt" value={booking.data.refund_init_obj.receipt} />
                <Row label="Amount" value={
                  booking.data.refund_init_obj.amount
                    ? `${booking.data.refund_init_obj.currency} ${Math.floor(booking.data.refund_init_obj.amount / 100)}`
                    : null
                } />
                <Row label="Currency" value={booking.data.refund_init_obj.currency} />

                {/* Refund Percentage */}
                <Row
                  label="Refund Percentage"
                  value={(() => {
                    const refundAmt = booking.data.refund_init_obj?.amount;
                    const totalAmt = booking.data.payment_detail?.payment?.entity?.amount;

                    if (!refundAmt || !totalAmt) return "—";

                    const percentage = ((refundAmt / totalAmt) * 100).toFixed(2);

                    return (
                      <span style={{
                        color: Number(percentage) >= 100 ? "#52c41a" : Number(percentage) >= 50 ? "#faad14" : "#ff4d4f",
                        fontWeight: 600,
                      }}>
                        {percentage}%
                      </span>
                    );
                  })()}
                />

                <Row label="Speed Requested" value={ToFirstCapital(booking.data.refund_init_obj.speed_requested)} />
                <Row label="Speed Processed" value={ToFirstCapital(booking.data.refund_init_obj.speed_processed)} />
                {/* <Row label="ARN" value={booking.data.refund_init_obj.acquirer_data?.arn || "—"} /> */}
                <Row label="Initiated At" value={
                  booking.data.refund_init_obj.created_at
                    ? new Date(booking.data.refund_init_obj.created_at * 1000).toLocaleString()
                    : null
                } />
              </div>
            </div>
          )
        }

        {
          Array.isArray(booking?.data?.properties) &&
          booking.data.properties.map((property) => (
            <div className="vb-card vb-card--property vb-card--span2" key={property._id}>
              <div className="vb-card__head">
                <span className="vb-card__title">
                  <span className="vb-card__dot vb-card__dot--sky" />
                  Property
                </span>
                <div className="vb-card__head-right">
                  <span style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "0.72rem",
                    color: "var(--vb-text-tertiary)",
                    letterSpacing: "0.04em",
                  }}>
                    #{property.property_id}
                  </span>
                  <div className={`vb-badge ${statusClass(property?.booking_status)}`}>
                    <span className="vb-badge__dot" />
                    {ToFirstCapital(property?.booking_status) || "—"}
                  </div>
                </div>
              </div>

              {property?.cover_photos?.length > 0 && (
                <div className="vb-photos">
                  {property.cover_photos.map((photo) => (
                    <img
                      key={photo._id}
                      src={photo.url}
                      alt={`Cover ${photo.index + 1}`}
                      className="vb-photos__img"
                    />
                  ))}
                </div>
              )}

              <div className="vb-card__body vb-card__body--grid3">
                <Row label="Property Type" value={ToFirstCapital(property?.property_type)} />
                <Row label="Construction Status" value={property?.construction_status} />
                <Row label="Booked Properties" value={booking?.data?.properties?.length} />
                <Row label="Possession Date" value={property?.possession_date} />
                <Row label="Tower Name" value={property?.tower_name || "No Tower"} />
                <Row label="Floor Number" value={property?.floor !== undefined && property?.floor !== null ? property.floor : null} />
                <Row label="Unit Number" value={property?.unitno} />
                <Row label="Unit Type" value={property?.unit} />
                <Row label="Furnishing" value={ToFirstCapital(property?.furnishing_status)} />
                <Row label="Transaction Currency" value={property?.currency} />
                <Row label="Completion Date" value={new Date(property?.created_at).toLocaleString()} />
                <Row label="Project Type" value={booking?.data?.project?.project_type?.name} />
                <Row label="Phases" value={
                  booking?.data?.phases?.length
                    ? booking.data.phases.map((p) => p.name).join(", ")
                    : null
                } />
                <Row label="Address" value={
                  booking?.data?.country?.country_name
                    ? `${booking?.data?.city?.city_name}, ${booking?.data?.state?.state_name}, ${booking?.data?.country?.country_name}`
                    : null
                } />
              </div>

              <div className="vb-prop-footer">
                <button className="vb-price-btn" onClick={priceModalHandler}>
                  <View />
                  Price Details
                </button>
                {pricePopup && (
                  <PriceDetailModal propertyData={property} onClick={priceModalHandler} />
                )}
                <button
                  className="vb-btn vb-btn--ghost"
                  onClick={() => navigate(`/manage_properties/view/${property?.property_id}`)}
                >
                  View Full Details
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </button>
              </div>
            </div>
          ))
        }
      </div >

      {notePopup && (
        <div className="vb-overlay">
          <div className="vb-modal">
            <div className="vb-modal__head">
              <span className="vb-modal__title">Cancellation Note</span>
              <button
                className="vb-modal__x"
                onClick={() => { setNotePopup(false); setNote(""); }}
                disabled={noteLoading}
              >✕</button>
            </div>
            <div className="vb-modal__body">
              <label className="vb-modal__field-label">Reason for cancellation</label>
              <textarea
                className="vb-modal__textarea"
                value={note}
                onChange={handleNoteChange}
                placeholder="Describe the reason for cancelling this booking…"
                disabled={noteLoading}
              />
            </div>
            <div className="vb-modal__foot">
              <button
                className="vb-btn vb-btn--secondary"
                onClick={() => { setNotePopup(false); setNote(""); }}
                disabled={noteLoading}
              >Discard</button>
              <button
                className="vb-btn vb-btn--primary"
                onClick={handleNoteSubmit}
                disabled={noteLoading}
              >
                {noteLoading
                  ? <TailSpin height="15" width="15" color="#fff" ariaLabel="loading" />
                  : "Full/Partial"}
              </button>
            </div>
            {noteLoading && (
              <div className="vb-modal__loader">
                <TailSpin height="40" width="40" color="var(--vb-accent)" ariaLabel="loading" />
              </div>
            )}
          </div>
        </div>
      )}

      {
        refundPopup && (
          <div className="vb-overlay">
            <div className="vb-modal" style={{ maxWidth: "460px", width: "100%" }}>
              <div
                className="vb-modal__head"
                style={{
                  background: "#0D152B",
                  borderRadius: "12px 12px 0 0",
                  padding: "20px 24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.12)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "18px"
                  }}
                >
                  ↩
                </div>

                <div>
                  <p style={{ color: "white", fontWeight: 600, fontSize: "15px", margin: 0 }}>
                    Confirm Refund Type
                  </p>
                  <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "12px", margin: 0 }}>
                    Booking ID: {booking?.data?.booking_id || "—"}
                  </p>
                </div>

                <button
                  className="vb-modal__z"
                  onClick={() => {
                    if (!cancelLoading) {
                      setRefundPopup(false);
                      setRefundType("full");
                      setDeductionPercentage(null);
                      setPercentageError("");
                    }
                  }}
                  disabled={cancelLoading}
                  style={{ marginLeft: "auto", color: "#fff" }}
                >
                  ✕
                </button>
              </div>

              <div className="vb-modal__body" style={{ padding: "24px" }}>
                <div
                  style={{
                    background: "#f5f7fa",
                    border: "1px solid #e8e8e8",
                    borderRadius: "10px",
                    padding: "14px 18px",
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <span style={{ fontSize: "13px", color: "#888" }}>Booking Amount</span>
                  <span style={{ fontSize: "18px", fontWeight: 600, color: "#0D152B" }}>
                    {booking?.data?.currency || booking?.data?.booking_amount_currency || "₹"}{" "}
                    {booking?.data?.booking_amount || booking?.data?.total || "—"}
                  </span>
                </div>

                <p style={{ fontSize: "13px", color: "#888", marginBottom: "10px", fontWeight: 500 }}>
                  SELECT REFUND TYPE
                </p>

                <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
                  <div
                    onClick={() => {
                      if (!cancelLoading) {
                        setRefundType("full");
                        setDeductionPercentage(null);
                        setPercentageError("");
                      }
                    }}
                    style={{
                      flex: 1,
                      border: refundType === "full" ? "2px solid #0D152B" : "1.5px solid #e0e0e0",
                      borderRadius: "10px",
                      padding: "14px 16px",
                      cursor: cancelLoading ? "not-allowed" : "pointer",
                      background: refundType === "full" ? "#f0f2f8" : "white",
                      transition: "all 0.2s",
                      position: "relative"
                    }}
                  >
                    {refundType === "full" && (
                      <div
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          width: "18px",
                          height: "18px",
                          borderRadius: "50%",
                          background: "#0D152B",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <span style={{ color: "white", fontSize: "11px", lineHeight: 1 }}>✓</span>
                      </div>
                    )}

                    <p style={{ fontWeight: 600, fontSize: "14px", margin: "0 0 4px", color: "#0D152B" }}>
                      Full Refund
                    </p>
                    <p style={{ fontSize: "12px", color: "#888", margin: 0 }}>
                      100% returned to customer
                    </p>
                  </div>

                  <div
                    onClick={() => {
                      if (!cancelLoading) {
                        setRefundType("partial");
                      }
                    }}
                    style={{
                      flex: 1,
                      border: refundType === "partial" ? "2px solid #0D152B" : "1.5px solid #e0e0e0",
                      borderRadius: "10px",
                      padding: "14px 16px",
                      cursor: cancelLoading ? "not-allowed" : "pointer",
                      background: refundType === "partial" ? "#f0f2f8" : "white",
                      transition: "all 0.2s",
                      position: "relative"
                    }}
                  >
                    {refundType === "partial" && (
                      <div
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          width: "18px",
                          height: "18px",
                          borderRadius: "50%",
                          background: "#0D152B",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <span style={{ color: "white", fontSize: "11px", lineHeight: 1 }}>✓</span>
                      </div>
                    )}

                    <p style={{ fontWeight: 600, fontSize: "14px", margin: "0 0 4px", color: "#0D152B" }}>
                      Partial Refund
                    </p>
                    <p style={{ fontSize: "12px", color: "#888", margin: 0 }}>
                      Deduct a percentage
                    </p>
                  </div>
                </div>

                {refundType === "partial" && (
                  <div
                    style={{
                      background: "#fafafa",
                      border: "1px solid #e8e8e8",
                      borderRadius: "10px",
                      padding: "16px",
                      marginBottom: "4px"
                    }}
                  >
                    <label
                      style={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#555",
                        display: "block",
                        marginBottom: "8px"
                      }}
                    >
                      Deduction Percentage <span style={{ color: "red" }}>*</span>
                    </label>

                    <input
                      type="number"
                      min={0}
                      max={100}
                      value={deductionPercentage ?? ""}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        setDeductionPercentage(e.target.value === "" ? null : value);

                        if (value > 100) setPercentageError("Percentage cannot exceed 100.");
                        else if (value < 0) setPercentageError("Percentage cannot be less than 0.");
                        else setPercentageError("");
                      }}
                      placeholder="e.g. 20"
                      disabled={cancelLoading}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #d9d9d9",
                        padding: "10px 12px"
                      }}
                    />

                    {percentageError && (
                      <p style={{ color: "red", fontSize: "12px", margin: "6px 0 0" }}>
                        {percentageError}
                      </p>
                    )}

                    {deductionPercentage !== null &&
                      deductionPercentage >= 0 &&
                      deductionPercentage <= 100 &&
                      !percentageError && (
                        <div style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
                          <div
                            style={{
                              flex: 1,
                              background: "#fff0f0",
                              border: "1px solid #ffd6d6",
                              borderRadius: "8px",
                              padding: "10px 12px",
                              textAlign: "center"
                            }}
                          >
                            <p style={{ fontSize: "11px", color: "#c0392b", margin: "0 0 2px" }}>
                              Deducted
                            </p>
                            <p style={{ fontSize: "15px", fontWeight: 600, color: "#c0392b", margin: 0 }}>
                              {deductionPercentage}%
                            </p>
                          </div>

                          <div
                            style={{
                              flex: 1,
                              background: "#f0fff4",
                              border: "1px solid #b7ebc4",
                              borderRadius: "8px",
                              padding: "10px 12px",
                              textAlign: "center"
                            }}
                          >
                            <p style={{ fontSize: "11px", color: "#27ae60", margin: "0 0 2px" }}>
                              Customer gets
                            </p>
                            <p style={{ fontSize: "15px", fontWeight: 600, color: "#27ae60", margin: 0 }}>
                              {100 - deductionPercentage}%
                            </p>
                          </div>
                        </div>
                      )}
                  </div>
                )}
              </div>

              <div className="vb-modal__foot">
                <button
                  className="vb-btn vb-btn--secondary"
                  onClick={() => {
                    setRefundPopup(false);
                    setRefundType("full");
                    setDeductionPercentage(null);
                    setPercentageError("");
                  }}
                  disabled={cancelLoading}
                >
                  Cancel
                </button>

                <button
                  className="vb-btn vb-btn--primary"
                  onClick={handleCancelBookingConfirmed}
                  disabled={cancelLoading}
                >
                  {cancelLoading ? "Processing..." : "Confirm Refund"}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        confirmReward && (
          <div className="vb-overlay">
            <div className="vb-modal vb-modal--confirm">
              <div className="vb-modal__head">
                <span className="vb-modal__title">Confirm Reward Points</span>
                <button
                  className="vb-modal__x"
                  onClick={() => { setConfirmReward(false); setPendingPoints(null); }}
                >✕</button>
              </div>
              <div className="vb-modal__body">
                <div className="vb-confirm__icon">⭐</div>
                <p className="vb-confirm__text">
                  Assign <strong>{pendingPoints}</strong> reward points to this user?
                  This action cannot be undone.
                </p>
              </div>
              <div className="vb-modal__foot">
                <button
                  className="vb-btn vb-btn--secondary"
                  onClick={() => { setConfirmReward(false); setPendingPoints(null); }}
                >Cancel</button>
                <button
                  className="vb-btn vb-btn--primary"
                  onClick={handleRewardPointsSubmitConfirmed}
                >Confirm & Assign</button>
              </div>
            </div>
          </div>
        )
      }
      {finalSummaryPopup && (
        <FinalSummaryPopup
          bookingId={booking?.data?._id}
          existingData={booking?.data?.final_summary}
          currency={booking?.data?.currency}
          onClose={() => setFinalSummaryPopup(false)}
          onSuccess={() => {
            setFinalSummaryPopup(false);
            dispatch(getBookingsListById(id));
          }}
        />
      )}
    </div >
  );
};

export default ViewBooking;